export default class CreateFeedItem{

    text;
    file;
    constructor() {
        this.text = null;
        this.file = null;
    }
}
